import Contact from "../../../components/Contact/Contact";

const ContactPage = () => {
    return (
        <Contact></Contact>
    );
}

export default ContactPage;
